import { Injectable, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { Constants } from 'projects/shared/src/app/shared/constants/constants';
import { Helpers } from 'projects/training-calendar/src/app/helpers';

export const ASSESSMENT_AGENCY_STATUS = {
	ASSESSMENT_AGENCY_BLOCKED: 'BLOCKED',
	ASSESSMENT_AGENCY_WARNING: 'WARN',
	ASSESSMENT_AGENCY_SUSPENDED: 'SUSPENDED',
}

export class AssessmentAgencyStatusCRPaylod {
	newAssessmentAgencyState = {
		status: ''
	}
	constructor(newStatus: string, public reason: string, public comment: string, public supportingDocuments?: string[]) {
		this.newAssessmentAgencyState.status = newStatus;
	}
}

export class AssessmentAgencyStatusCRPatch {
	newAssessmentAgencyState = {
		status: ''
	}
	constructor(newStatus: string, public sscComment, public duration, public actionStatus = 'ACCEPTED') {
		this.newAssessmentAgencyState.status = newStatus;
	}
}

interface IAssessmentAgencyStatusCRPatch {
	sscComment: string,

}

@Injectable({ providedIn: 'root' })
export class AssessmentAgencyService {
	public setWhatToShow1 = new EventEmitter();
	public setWhatToShow2 = new EventEmitter();
	public what;
	public assessor;
	constructor(private apiService: ApiService) { }

	setWhatToshow(text) {
		this.what = text;
	}
	getWhatToShow() {
		return this.what;
	}
	getAssesmentAgencyBasedOnLocation(
		state: number, district: number, type = '',
		pageNo = 1, itemsPerPage, name = '', userName = '', ssc = '', biceId?) {
		const masterTrainerUrl = `${environment.userServiceUrl}/api/user/v1/assessmentAgencyLocationBased`;
		console.log(masterTrainerUrl);
		return this.apiService.get(masterTrainerUrl, {
			itemsPerPage: itemsPerPage,
			pageNo: pageNo,
			state: state,
			district: district,
			name: name,
			userName: userName,
			type: type,
			sscName: ssc,
			biceId: biceId || ''
		});

	}

	getAssessmentAgencyList(pageNo = 1, itemsPerPage, filter) {
		let queryParms = {
			'pageNo': pageNo,
			'itemPerPage': itemsPerPage
		}
		queryParms = Object.assign({}, queryParms, filter)
		const masterTrainerUrl = `${environment.userServiceUrl}/api/user/v1/assessmentAgency?`;
		console.log(masterTrainerUrl);
		return this.apiService.get(masterTrainerUrl, queryParms);

	}


	checkAssessorAvailablity(batchId, assessorId) {
		const url = `${environment.userServiceUrl}/api/batch/v1/pmkvy/get/batchlist/assessor?batchId=${batchId}&arid=${assessorId}`;
		return this.apiService.get(url);
	}
	getPendingAssessmentAgency(pageNo, itemsPerPage, query?: any) {
		Object.assign(query, {
			pageNo: pageNo,
			sortBy: '-_id'
		});
		const url = `${environment.userServiceUrl}/api/user/v1/assessmentAgency/get/approval/request?pageNo=${pageNo}&limit=${itemsPerPage}`;
		return this.apiService.get(url, query);
	}
	getAssesmentAgency({ pageNo = 1, limit = 20, noPagination = false }: any = {}, query: any = {}) {
		// const query: any = {
		// 	pageNo: pageNo,
		// 	limit: limit,
		// };
		Object.assign(query, {
			pageNo: pageNo,
			limit: limit,
			sortBy: '-_id'
		});
		if (noPagination) {
			query.pagination = 'no';
		}
		// http://localhost:3000/v1/user/assesment-agency/assessor?pageNo=1&itemsPerPage=10&jobRoleId=QP-46
		const URL = `${environment.userServiceUrl
			}/api/user/v1/assessmentAgency`;
		return this.apiService.get(URL, query);
	}

	getSIIBAssesmentAgency({ pageNo = 1, limit = 20, noPagination = false }: any = {}, query: any = {}) {
		Object.assign(query, {
			pageNo: pageNo,
			limit: limit,
			sortBy: '-_id'
		});
		if (noPagination) {
			query.pagination = 'no';
		}
		const URL = `${environment.userServiceUrl
			}/api/user/v1/thirdpartyAgency`;
		return this.apiService.get(URL, query);
	}

	updateApprovalRequestforAA(status, userName) {
		const url = `${environment.userServiceUrl}/api/user/v1/assessmentAgency/update/approval/request`;
		console.log(url);
		return this.apiService.put(url, {
			status: status,
			userName: userName
		});
	}
	checkGstExistance(number) {
		const URL = `${environment.userServiceUrl
			}/api/user/v1/check/identificationnumber?keyword=GstNumber:${number}`
		return this.apiService.get(URL)

	}
	// checkPanExistance(number) {
	// 	const URL = `${
	// 		environment.userServiceUrl
	// 	}/api/user/v1/check/identificationnumber?keyword=PanNumber:${number}`
	// 	return this.apiService.get(URL)

	// }

	getNotActiveAssessmentAgencys({ pageNo = 1, itemsPerPage = 20, noPagination = false, AAstatus }: any = {}, query: any = {}) {
		// const query: any = {
		// 	pageNo: pageNo,
		// 	limit: limit,
		// };
		Object.assign(query, {
			pageNo: pageNo,
			limit: itemsPerPage,
			sortBy: '-_id'
		});
		console.log(AAstatus, noPagination);
		const statusRequired = [
			// ASSESSMENT_AGENCY_STATUS.ASSESSMENT_AGENCY_BLOCKED,
			// ASSESSMENT_AGENCY_STATUS.ASSESSMENT_AGENCY_SUSPENDED,
			// ASSESSMENT_AGENCY_STATUS.ASSESSMENT_AGENCY_WARNING,
			AAstatus
		]
		const statusDifferentiator = '---' // for separating statuses lates in server side we uses '---' as special char. don't change it.
		const status = statusRequired.join(statusDifferentiator);
		const backendQuery = Helpers.toBackendQuery({
			status,
		})
		// const query = {
		// 	query: backendQuery,
		// }
		query.query = backendQuery
		if (noPagination) {
			query.pagination = 'no';
		}
		const URL = `${environment.userServiceUrl
			}/api/user/v1/assessmentAgency`;
		return this.apiService.get(URL, query);
	}

	getAssessmentAgencyStatusChangeRequests(pagination?: any) {
		if (pagination) {
			pagination.limit = pagination.itemsPerPage
		}
		const backendQuery = Helpers.toBackendQuery({
			'changeRequests.status.actionStatus': 'CR_INIT'
		})
		const query = {
			query: backendQuery,
		}
		pagination = pagination || {
			pageNo: '1',
			limit: '20',
			sortBy: '',
			keyword: '',
		}
		const URL = `${environment.userServiceUrl}/api/user/v1/assessmentAgency?${Helpers.serialize(query)}`;
		return this.apiService.get(URL, pagination);
	}

	getAssesmentAgencyByUserName(userName) {
		const URL = `${environment.userServiceUrl
			}/api/user/v1/assessmentAgency/${userName}`;
		return this.apiService.get(URL);
	}
	// checkGstExistance(number) {
	// 	const URL = `${
	// 		environment.userServiceUrl
	// 	}/api/user/v1/check/identificationnumber?keyword=GstNumber:${number}`
	// 	return this.apiService.get(URL)

	// }
	checkPanExistance(number) {
		const URL = `${environment.userServiceUrl
			}/api/user/v1/check/identificationnumber?keyword=PanNumber:${number}`
		return this.apiService.get(URL)

	}


	getAssessor(ARID, BatchID) {
		console.log(ARID, BatchID);
		const URL = `${environment.userServiceUrl
			}/api/batch/v1/pmkvy/get/batchlist/assessor`;
		return this.apiService.get(URL, {
			arid: ARID,
			batchId: BatchID
		});
	}

	getAssessorsToAssign(jobRoleId: string,
		version: string,
		assessorType,
		pageNo = 1,
		perPage,
		batchType?,
		assessmentStartDate?,
		assessmentEndDate?,
		schemeType?,
		subSchemeType?,
		biceId?
	) {
		const URL = `${environment.userServiceUrl}/api/user/v1/assign/assessor/tobatch?`
		return this.apiService.get(URL, {
			pageNo: pageNo,
			itemsPerPage: perPage,
			jobRoleId: jobRoleId,
			version: version,
			type: assessorType,
			batchType: batchType,
			assessmentStartDate: assessmentStartDate ? assessmentStartDate : '',
			assessmentEndDate: assessmentEndDate ? assessmentEndDate : '',
			schemeType: schemeType || '',
			subSchemeType: subSchemeType || '',
			biceId: biceId || ''
		})
	}

	getProctorToAssign(jobRoleId: string,
		proctorType,
		pageNo = 1,
		perPage,
		batchType?,
		assessmentStartDate?,
		assessmentEndDate?,
		schemeType?,
		subSchemeType?,
		biceId?
	) {
		const URL = `${environment.userServiceUrl}/api/user/v1/assign/proctor/tobatch?`
		return this.apiService.get(URL, {
			pageNo: pageNo,
			itemsPerPage: perPage,
			jobRoleId: jobRoleId,
			type: proctorType,
			batchType: batchType,
			assessmentStartDate: assessmentStartDate ? assessmentStartDate : '',
			assessmentEndDate: assessmentEndDate ? assessmentEndDate : '',
			schemeType: schemeType || '',
			subSchemeType: subSchemeType || '',
			biceId: biceId || ''
		})
	}




	getAssessorsBasedOnQpCode(
		jobRoleId: string,
		assessorType,
		pageNo = 1,
		perPage = Constants.RECORDSPERPAGE,
		batchType?,
		data?
	) {
		console.log(data);
		const originationCategory = data && data.originationCategory ? data.originationCategory : '';
		const country = data && data.country !== 'IN' ? data.country : '';
		const state = data && data.state && data.state.code ? data.state.code : 0;
		const district = data && data.district && data.district.code ? data.district.code : 0;
		const aaId = data && data.id ? data.id : '';
		const name = data && data.name ? data.name : '';

		console.log('AM INSIDE', perPage)
		// http://localhost:3000/v1/user/assesment-agency/assessor?pageNo=1&itemsPerPage=10&jobRoleId=QP-46
		const URL = `${environment.userServiceUrl
			}/api/user/v1/assesment-agency/assessor`;
		return this.apiService.get(URL, {
			pageNo: pageNo,
			itemsPerPage: perPage,
			jobRoleId: jobRoleId,
			type: assessorType,
			batchType: batchType,
			originationCategory: originationCategory,
			countryCode: country,
			state: state,
			district: district,
			aId: aaId,
			name: name,
		});
	}

	// /api/user/v1/getassesorcount/{aaName}/{type}/{jobRoleId}/{batchType}
	getAABasedOnQpCode(data) {
		const URL = `${environment.userServiceUrl}/api/user/v1/getassesorcount`
		return this.apiService.get(URL, {
			aaName: data.aaName,
			version: data.version,
			type: data.type,
			jobRoleId: data.jobRoleId,
			batchType: data.batchType
		});
	}
	getAABasedOnQpCodeProctor(data) {
		const URL = `${environment.userServiceUrl}/api/user/v1/getproctorcount`
		return this.apiService.get(URL, {
			aaName: data.aaName,
			type: data.type,
			jobRoleId: data.jobRoleId,
			batchType: data.batchType
		});
	}
	assignBatchToAssessmentAgency(reqObj) {
		// http://localhost:3003/v1/batch/{batchId}/jobRoles/{qpCode}/assessmentAgencyDetails
		const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/batch/${reqObj.batchId
			}/jobRoles/assessmentAgencyDetails`;
		return this.apiService.patch(URL, {
			userName: reqObj.userName,
			name: reqObj.name,
			qpCode: reqObj.qpCode,
			email: reqObj.email,
			biceId: reqObj.biceId ? reqObj.biceId : '',
			assessmentType: reqObj.assessmentType,
			isPlatformQP: reqObj.isPlatformQP,
			isPwdQP: reqObj.isPwdQP
		});
	}
	assignAssessorToBatch(payload) {
		// http://localhost:3003/v1/batch/17/jobRoles/QP-5/assessmentAgencyDetails
		const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/batch/${payload.batchId
			}/jobRoles/assessmentAgencyDetails/assessor`;
		return this.apiService.patch(URL, payload
			// {
			// userName: payload.userName,
			// name: payload.name,
			// qpCode: payload.qpCode,
			// email: payload.email,
			// sscEmail: payload.sscEmail,
			// isPlatformQP: payload.isPlatformQP
			// }
		)
	}

	assignProctorToBatch(payload) {
		// http://localhost:3003/v1/batch/17/jobRoles/QP-5/assessmentAgencyDetails
		const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/batch/${payload.batchId
			}/jobRoles/assessmentAgencyDetails/proctor`;
		return this.apiService.patch(URL, payload
			// {
			// userName: payload.userName,
			// name: payload.name,
			// qpCode: payload.qpCode,
			// email: payload.email,
			// sscEmail: payload.sscEmail,
			// isPlatformQP: payload.isPlatformQP
			// }
		)
	}

	getAllAssessors(
		pageNo = 1,
		itemsPerPage = Constants.RECORDSPERPAGE,
		type = 'all'
	) {
		// http://localhost:3000/v1/user/assesment-agency/assessor?pageNo=0&itemsPerPage=0&jobRoleId&type=all

		const URL = `${environment.userServiceUrl
			}/api/user/v1/assesment-agency/assessor`;

		return this.apiService.get(URL, {
			pageNo: pageNo,
			itemsPerPage: itemsPerPage,
			jobRoleId: '',
			type: type
		});
	}
	getAssessorByUserName(userName) {
		// localhost:3000/v1/user/assessor/AR23
		const URL = `${environment.userServiceUrl
			}/api/user/v1/assessor/${userName}`;
		return this.apiService.get(URL);
	}
	getProctorByUserName(userName) {
		// localhost:3000/v1/user/assessor/AR23
		const URL = `${
			environment.userServiceUrl
			}/api/user/v1/proctor/${userName}`;
		return this.apiService.get(URL);
	}
	approveMarksForBatch(payload) {
		// http://localhost:3003/v1/batch/17/jobRoles/QP-5/assessmentAgencyDetails
		const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/batch/approval/${payload.batchId
			}`;
		let data;
		if (payload.status === 'SSC & AA REJECTED') {
			data = {
				status: payload.status
			};
		} else {
			data = {
				status: payload.status,
				review: payload.remarks
			};
		}
		if (payload.assessmentStatus) {
			data.assessmentStatus = payload.assessmentStatus;
		}
		return this.apiService.put(URL, data);
	}
	approveMarksForCandidate(payload) {
		// http://localhost:3003/v1/batch/17/jobRoles/QP-5/assessmentAgencyDetails
		const URL = `${environment.ToTServiceURL}/api/tot-toa/v1/batch/candidate/approval/${payload.batchId
			}/${payload.userName}`;
		return this.apiService.put(URL, {
			status: payload.status,
			review: payload.remarks
		});
	}
	getAllAssessorsNew() {
		// http://localhost:3000/v1/user/assesment-agency/assessor?pageNo=0&itemsPerPage=0&jobRoleId&type=all

		// const URL = `${
		//     environment.userServiceUrl
		//     }/api/user/v1/assesment-agency/assessor`;

		const URL = `${environment.userServiceUrl
			}/api/user/v1/assessmentAgency/get/assessor`;

		return this.apiService.get(URL);
	}

	linkAssessmentAgencyToSCC(userName, phone_otp, email_otp, reqObj) {
		// localhost:3000/api/user/v1/ssc/linkAA?aaId=AA_000001
		const URL = `${environment.userServiceUrl}/api/user/v1/ssc/linkAA?aaId=${userName}&phone_otp=${phone_otp}&email_otp=${email_otp}`;
		console.log('URL', URL);

		return this.apiService.patch(URL, reqObj);
	}

	extendAssessmentAgencyToSSC(userName, phone_otp, email_otp, reqObj) {
		const URL = `${environment.userServiceUrl}/api/batch/v1/extend/ssc/aa/link/duration?aaId=${userName}&phone_otp=${phone_otp}&email_otp=${email_otp}`;
		return this.apiService.patch(URL, reqObj);
	}


	// For AA while linking AA or Assigning AA time? n which key? for RPL4 only?
	assessmentAgencyRegistration(userName, payLoad) {
		const URL = `${environment.userServiceUrl}/api/user/v1/update/${userName}`;
		return this.apiService.patch(URL, payLoad, true)
	}

	getAssessmentAgencyRegDd() {
		const URL = `${environment.userServiceUrl}/api/user/v1/get/dropdown/data`;
		return this.apiService.get(URL);
	}

	editAAProfileFirstPage(body) {
		const URL = `${environment.userServiceUrl}/api/user/v1/assessmentAgency`;
		return this.apiService.put(URL, body);
	}

	getMyAA() {
		const URL = `${environment.userServiceUrl}/api/user/v1/ssc/assessmentAgency`;
		return this.apiService.get(URL)
	}

	aAapproveReject(params) {
		const URL = `${environment.userServiceUrl}/api/user/v1/ssc/assessmentAgency `;
		return this.apiService.put(URL, params)
	}

	getAssociateSSc(userName) {
		const URL = `${environment.userServiceUrl}/api/user/v1/assessmentAgency/ssc?username=${userName}`;
		return this.apiService.get(URL)
	}

	getAssociateAA(userName) {
		const URL = `${environment.userServiceUrl}/api/user/v1/assessmentAgency/link/assessors/${userName}`;
		return this.apiService.get(URL);
	}
	assessmentAgencyStatusCR(assessmentAgencyId, assessmentAgencyCR: AssessmentAgencyStatusCRPaylod) {
		const url = `${environment.userServiceUrl}/api/user/v1/assessmentAgency/cr/insertAssessmentAgencyStatusChangeCR/${assessmentAgencyId}?showServerSuccessMessage=true`
		return this.apiService.post(url, assessmentAgencyCR);
	}

	acceptAssessmentAgencyStatusCR(assessmentAgencyId, assessmentAgencyCR: AssessmentAgencyStatusCRPatch) {
		const url = `${environment.userServiceUrl}/api/user/v1/assessmentAgency/cr/acceptAssessmentAgencyStatusChangeCR/${assessmentAgencyId}?showServerSuccessMessage=true`
		return this.apiService.post(url, assessmentAgencyCR);
	}

	blacklistAssessmentAgencyRequest(assessmentAgencyId: string, comment: string, reason?: string, supportingDocuments?: string[]) {
		const payload = new AssessmentAgencyStatusCRPaylod(
			ASSESSMENT_AGENCY_STATUS.ASSESSMENT_AGENCY_BLOCKED,
			reason,
			comment,
			supportingDocuments,
		);
		return this.assessmentAgencyStatusCR(assessmentAgencyId, payload)
	}

	// get pdf of AA using username
	getAAPdf(assessmentAgencyId) {
		const url = `${environment.pdfGenerate}/api/v1/generatepdfreports/generateassessmentagencyreports/?UserName=${assessmentAgencyId}`;
		return this.apiService.get(url);
	}

	checkReAssessmentEligibility(qpCode, batchId, schemeObjId) {
		const URL = `${environment.userServiceUrl}/api/batch/v1/reassessment/validation?qpCode=${qpCode}&batchId=${batchId}&schemeObjId=${schemeObjId}`;
		// const URL = `${environment.userServiceUrl}/api/batch/v1/reassessment/validation?qpCode=${qpCode}&batchId=${batchId}`;
		return this.apiService.get(URL);
	}

	// To get failed or absent candidates from parent non-pmkvy regular batch
	getCandidatesForNonPmkvyReassessmentBatchCreation(batchId, pageNo, itemsPerPage) {
		const URL = `${environment.userServiceUrl}/api/batch/v1/nonPmkvy/getCandidates/failAndNotAppread?batchID=${batchId}&pageNo=${pageNo}&itemsPerPage=${itemsPerPage}`;
		// const URL = `${environment.userServiceUrl}/api/batch/v1/reassessment/validation?qpCode=${qpCode}&batchId=${batchId}`;
		return this.apiService.get(URL);
	}

	SubmitReassessmentBatch(versionCode, batchId, qpCode, payLoad) {
		const URL = `${environment.userServiceUrl}/api/batch/v1/submit/reassessment/batch?version=${versionCode}&batchId=${batchId}&qpCode=${qpCode}`;
		return this.apiService.post(URL, payLoad);
	}
	reSubmitReassessmentBatch(versionCode, batchId, rABatchId, qpCode, payLoad) {
		const URL = `${environment.userServiceUrl}/api/batch/v1/submit/reassessment/batch?version=${versionCode}&batchId=${batchId}&RABatchId=${rABatchId}&qpCode=${qpCode}`;
		return this.apiService.post(URL, payLoad);
	}

	getAssessmentAgenciesByTpId(pageNo, itemsPerPage) {
		const url = `${environment.userServiceUrl}/api/user/v1/assessmentAgency?type=Feebased&pageNo=${pageNo}&limit=${itemsPerPage}`;
		return this.apiService.get(url)
	}

	getAllAssessmentagency({ pageNo, limit }, data) {
		const url = `${environment.userServiceUrl}/api/user/v1/pmkvy/assessmentAgencies`
		return this.apiService.get(url, {

			type: data.type || '',
			state: data.state || '',
			keyword: data.keyword || '',
			status: data.status || '',
			pageNo: pageNo,
			limit: limit,
			sortBy: '-_id',

		})
	}

}

